export const normalizeKioskAuthMode = (kioskAuthMode) => {
  if (kioskAuthMode === "userIdPin") {
    return "userId";
  }

  return kioskAuthMode;
};

export const withNormalizedKioskAuthMode = (payload) => {
  if (!payload) {
    return payload;
  }

  return {
    ...payload,
    kioskAuthMode: normalizeKioskAuthMode(payload.kioskAuthMode),
  };
};

export const getCompanyInfoFromStorage = () => {
  const storedCompanyInfo = localStorage.getItem("companyInfo");

  if (!storedCompanyInfo) {
    return null;
  }

  const parsedCompanyInfo = JSON.parse(storedCompanyInfo);
  const normalizedCompanyInfo = withNormalizedKioskAuthMode(parsedCompanyInfo);

  if (parsedCompanyInfo.kioskAuthMode !== normalizedCompanyInfo.kioskAuthMode) {
    localStorage.setItem("companyInfo", JSON.stringify(normalizedCompanyInfo));
  }

  return normalizedCompanyInfo;
};

export const syncStoredKioskAuthMode = (kioskAuthMode) => {
  const normalizedKioskAuthMode = normalizeKioskAuthMode(kioskAuthMode);

  if (!normalizedKioskAuthMode) {
    return false;
  }

  const storedCompanyInfo = getCompanyInfoFromStorage();

  if (!storedCompanyInfo || storedCompanyInfo.kioskAuthMode === normalizedKioskAuthMode) {
    return false;
  }

  localStorage.setItem(
    "companyInfo",
    JSON.stringify({
      ...storedCompanyInfo,
      kioskAuthMode: normalizedKioskAuthMode,
    })
  );

  return true;
};

export const isUserIdKioskAuthMode = (kioskAuthMode) =>
  normalizeKioskAuthMode(kioskAuthMode) === "userId";